(function () {
  "use strict";

  var BEACON_URL = "https://api.byinfant.com/storefront-loaded.gif";

  function readTrackingCode() {
    try {
      return new URLSearchParams(window.location.search).get("ce_trk") || "";
    } catch (_error) {
      return "";
    }
  }

  function performanceValue(name) {
    try {
      var navigation = performance.getEntriesByType("navigation")[0];
      if (navigation && Number.isFinite(navigation[name])) {
        return Math.max(0, Math.round(navigation[name]));
      }
    } catch (_error) {
      return 0;
    }
    return 0;
  }

  function firstContentfulPaint() {
    try {
      var paints = performance.getEntriesByType("paint");
      for (var i = 0; i < paints.length; i += 1) {
        if (paints[i].name === "first-contentful-paint") {
          return Math.max(0, Math.round(paints[i].startTime));
        }
      }
    } catch (_error) {
      return 0;
    }
    return 0;
  }

  function sendBeacon() {
    var code = readTrackingCode();
    if (!code || window.__infantStorefrontLoadedSent === code) {
      return;
    }
    window.__infantStorefrontLoadedSent = code;

    var params = new URLSearchParams();
    params.set("ce_trk", code.slice(0, 80));
    params.set("href", window.location.href.slice(0, 900));
    params.set("path", window.location.pathname.slice(0, 300));
    params.set("load_ms", String(performanceValue("domContentLoadedEventEnd") || Math.round(performance.now())));
    params.set("fcp_ms", String(firstContentfulPaint()));
    params.set("_", String(Date.now()));

    var image = new Image(1, 1);
    image.referrerPolicy = "no-referrer-when-downgrade";
    image.src = BEACON_URL + "?" + params.toString();
  }

  function scheduleBeacon() {
    if (!readTrackingCode()) {
      return;
    }
    window.requestAnimationFrame(function () {
      setTimeout(sendBeacon, 0);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleBeacon, { once: true });
  } else {
    scheduleBeacon();
  }
})();
